// import { Post } from "./http";

// const ip = 'http://81.70.145.108'
// const servicePort = ':19099'

// // 发送验证短信
// export function ApplaySms(data,callback){
//     let url = ip +servicePort +'/api/Apply/ApplaySms'
//     console.log(JSON.stringify(data),'验证短信接口');
//     Post(url,JSON.stringify(data),callback)
// }

// // 申请提交
// export function ApplaySubmit(data,callback){
//     let url = ip +servicePort +'/api/Apply/ApplaySubmit'
//     console.log(JSON.stringify(data),'验证短信接口');
//     Post(url,JSON.stringify(data),callback)
// }

// // 管理员登录
// export function Login(data,callback){
//     let url = ip +servicePort +'/api/TrustUser/Login'
//     console.log(JSON.stringify(data),'管理员登录');
//     Post(url,JSON.stringify(data),callback)
// }

// // /api/TrustUser/LoginSms
// // 管理员发送短信
// export function LoginSms(data,callback){
//     let url = ip +servicePort +'/api/TrustUser/LoginSms'
//     console.log(JSON.stringify(data),'管理员登录短信验证');
//     Post(url,JSON.stringify(data),callback)
// }

import request from './http'

// 发送验证短信
export function ApplaySms(data){
    return request({
        url:'/api/Apply/ApplaySms',
        method:'post',
        data:data
    })
}

// 申请提交
export function ApplaySubmit(data){
    return request({
        url:'/api/Apply/ApplaySubmit',
        method:'post',
        data:data
    })
}

// 管理员登录
export function Login(data){
    return request({
        url:'/api/TrustUser/Login',
        method:'post',
        data:data
    })
}

// 管理员发送短信
export function LoginSms(data){
    return request({
        url:'/api/TrustUser/LoginSms',
        method:'post',
        data:data
    })
}
// /api/DataManager/ApplyCountStatistics
// 管理员 申请数量查询
export function ApplyCountStatistics(data){
    return request({
        url:'/api/DataManager/ApplyCountStatistics',
        method:'post',
        data:data
    })
}


// 管理员 申请状态查询
export function ApplyStateStatistics(data){
    return request({
        url:'/api/DataManager/ApplyStateStatistics',
        method:'post',
        data:data
    })
}


// 管理员 料盒查询
export function BoxStateStatistics(data){
    return request({
        url:'/api/DataManager/BoxStateStatistics',
        method:'post',
        data:data
    })
}


// 管理员 查询逾期未取
export function QueryStayBox(data){
    return request({
        url:'/api/Box/QueryStayBox',
        method:'post',
        data:data
    })
}


// 管理员 查询身份证号码池
export function QueryIdCardPool(data){
    return request({
        url:'/api/DataManager/QueryIdCardPool',
        method:'post',
        data:data
    })
}

// 管理员 查询申请信息
export function QueryApplyInfo(data){
    return request({
        url:'/api/DataManager/QueryApplyInfo',
        method:'post',
        data:data
    })
}

// 管理员 修改申请数据
export function ModifyApplyInfo(data){
    return request({
        url:'/api/DataManager/ModifyApplyInfo',
        method:'post',
        data:data
    })
}

// 管理员 重置身份证申请次数
export function ResetIdCardApply(data){
    return request({
        url:'/api/DataManager/ResetIdCardApply',
        method:'post',
        data:data
    })
}

// 管理员 查询用户信息
export function QueryUser(data){
    return request({
        url:'/api/TrustUser/QueryUser',
        method:'post',
        data:data
    })
}


// 管理员 修改用户信息
export function ModifyUser(data){
    return request({
        url:'/api/TrustUser/ModifyUser',
        method:'post',
        data:data
    })
}

// 管理员 注册/添加用户
export function AddUser(data){
    return request({
        url:'/api/TrustUser/AddUser',
        method:'post',
        data:data
    })
}

// 管理员 删除用户
export function DeleteUser(data){
    return request({
        url:'/api/TrustUser/DeleteUser',
        method:'post',
        data:data
    })
}


// 添加白名单用户
export function AddWhiteList(data){
    return request({
        url:'/api/WhiteList/AddUser',
        method:'post',
        data:data
    })
}

// 查询白名单用户
export function QueryWhiteList(data){
    return request({
        url:'/api/WhiteList/Query',
        method:'post',
        data:data
    })
}

// 修改白名单用户
export function ModifyWhiteList(data){
    return request({
        url:'/api/WhiteList/ModifyUser',
        method:'post',
        data:data
    })
}

// 删除白名单用户
export function DeleteWhiteList(data){
    return request({
        url:'/api/WhiteList/DeleteUser',
        method:'post',
        data:data
    })
}

// 查看照片
export function QueryApplyPhoto(photoPath){
    return request({
        url:'/api/DataManager/QueryApplyPhoto',
        method:'post',
        params:{photoPath}
    })
}

// 取牌申请状态查询
export function QueryApply(data){
    return request({
        url:'/api/Apply/QueryApply',
        method:'post',
        data:data
    })
}

// 查询车牌存储信息
export function QueryBoxInfo(data){
    return request({
        url:'/api/Box/QueryBoxInfo',
        method:'post',
        data:data
    })
}

// 查询车牌存储信息
export function QueryHistory(data){
    return request({
        url:'/api/History/QueryHistory',
        method:'post',
        data:data
    })
}

// 查询工作站字典信息
export function QueryStationDic(data){
    return request({
        url:'/api/StationDic/Query',
        method:'post',
        data:data
    })
}


// 工作站用户登录
export function StationUserLogin(data){
    return request({
        url:'/api/StationUser/Login',
        method:'post',
        data:data
    })
}

// 添加工作站用户
export function AddStationUser(data){
    return request({
        url:'/api/StationUser/AddUser',
        method:'post',
        data:data
    })
}


// 删除工作站用户
export function DeleteStationUser(data){
    return request({
        url:'/api/StationUser/DeleteUser',
        method:'post',
        data:data
    })
}


// 修改工作站用户信息
export function ModifyStationUser(data){
    return request({
        url:'/api/StationUser/ModifyUser',
        method:'post',
        data:data
    })
}


// 查询工作站用户信息
export function QueryStationUser(data){
    return request({
        url:'/api/StationUser/QueryUser',
        method:'post',
        data:data
    })
}

// 查询工作站任务信息
export function QueryStationTask(data){
    return request({
        url:'/api/StationTask/QueryTask',
        method:'post',
        data:data
    })
}

// 更新工作站任务信息
export function UpdateTaskState(data){
    return request({
        url:'/api/StationTask/UpdateTaskState',
        method:'post',
        data:data
    })
}


// 按时间查询过期料盒信息及联系信息
export function QueryExpiryBoxInfo(data){
    return request({
        url:'/api/DataManager/QueryExpiryBoxInfo',
        method:'post',
        data:data
    })
}


// 按时间查询取牌统计信息
export function ExportGetPlateStatistics(data){
    return request({
        url:'/api/DataManager/ExportGetPlateStatistics',
        method:'post',
        data:data
    })
}


// 按时间查询服务站号牌领取信息
export function ExportStationGetPlateStatistics(data){
    return request({
        url:'/api/DataManager/ExportStationGetPlateStatistics',
        method:'post',
        data:data
    })
}


// 转邮寄 获取 URL
export function ApplyEmsUrl(data){
    return request({
        url:'/api/Apply/ApplyEmsUrl',
        method:'post',
        data:data
    })
}















